import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchLeadEdit, editLead,
} from "Actions/Admin/Lead/LeadActions";



/**
 * The Lead Edit Dialog
 */
class LeadEdit extends React.Component {
    // The Initial Data
    initialData = {
        leadID      : 0,
        originID    : 0,
        interestID  : 0,
        description : "",
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, fetchLeadEdit } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchLeadEdit(elemID);
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition && elemID) {
            data = Utils.extend(this.initialData, elem);
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editLead(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { open, onClose, origins, interests } = this.props;
        const { data, loading, errors             } = this.state;

        return <EditDialog
            open={open}
            icon="lead"
            title="LEADS_EDIT_TITLE"
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                type="select"
                name="originID"
                label="LEADS_ORIGIN"
                value={data.originID}
                error={errors.originID}
                onChange={this.handleChange}
                options={origins}
                withNone
                isRequired
            />
            <InputField
                type="select"
                name="interestID"
                label="LEADS_INTEREST"
                value={data.interestID}
                error={errors.interestID}
                onChange={this.handleChange}
                options={interests}
                withNone
                isRequired
            />
            <InputField
                type="textarea"
                name="description"
                label="LEADS_ITS_DESCRIPTION"
                value={data.description}
                error={errors.description}
                onChange={this.handleChange}
                isRequired
            />
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchLeadEdit : PropTypes.func.isRequired,
        editLead      : PropTypes.func.isRequired,
        open          : PropTypes.bool.isRequired,
        onClose       : PropTypes.func.isRequired,
        onSubmit      : PropTypes.func.isRequired,
        edition       : PropTypes.number.isRequired,
        origins       : PropTypes.array.isRequired,
        interests     : PropTypes.array.isRequired,
        elem          : PropTypes.object.isRequired,
        elemID        : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition   : state.lead.edition,
            origins   : state.lead.origins,
            interests : state.lead.interests,
            elem      : state.lead.elem,
        };
    }
}

export default connect(LeadEdit.mapStateToProps, {
    fetchLeadEdit, editLead,
})(LeadEdit);
